//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import {mapGetters, mapState} from 'vuex'
import { asyncDataCatch, asyncDataStart } from '~/utils/asyncData'
import OffersInMailbox from '~/components/section/offers-in-mailbox'
import RequestAction from '~/components/global/RequestAction.vue'
import sectionIndex from '~/components/section/index/section.vue'
import { Breadcrumbs } from '~/plugins/breadcrumbs'
import { CACHE_SETTINGS } from '~/utils/cache'
import VRating from '~/components/v/rating'
import {getboatTypesHome, getReviews} from '~/utils/server'
import BlogSearch from '~/components/form/blog-search'
import BlogMenu from '~/components/section/blog-menu'
import OtherLocations from '~/components/seo/other-locations.vue'

export default {
  name: 'BlogsPage',
  components: {
    OtherLocations,
    BlogMenu,
    BlogSearch,
    OffersInMailbox,
    RequestAction,
    sectionIndex,
    VRating
  },
  async asyncData (ctx) {
    await asyncDataStart(ctx)
    const breadcrumbs = []
    try {
      let page = null
      const ietfLocale = ctx.store.getters['lang/currentLanguage']?.ietf_locale
      const lang = ctx.store.getters['lang/locale']
      const ietf = ietfLocale || 'en-gb'
      const { data } = await ctx.$axios.get('/api/blogs?lang=' + lang)
      page = data

      if (Object.keys(page).length === 0) {
        ctx.error({ statusCode: 404, message: 'Page not found' })
        return
      }
      const boatTypes = await ctx.$cacheFetch({
        key: `pIndex-getboatTypesHome?lang=${lang}&ietf=${ietf}`, expire: CACHE_SETTINGS.baseTime
      }, async () => {
        return await getboatTypesHome(ctx, { lang, ietf })
      })

      breadcrumbs.push({
        title: 'Blogs',
        url: `${ctx.store.getters['lang/locale']}/blog/`
      })
      const crubms = await Breadcrumbs.get(ctx.app.i18n, 'page', ctx.route, breadcrumbs)
      await ctx.store.dispatch('setBreadcrumbs', crubms)

      return {
        lang,
        page,
        boatTypes
      }
    } catch (e) {
      return asyncDataCatch(ctx, e)
    }
  },
  data () {
    return {
      hover: {
        sh: false,
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    this.$Search.resetAllAttributes(true)
    next()
  },
  head () {
    return {
      title: this.page?.data.meta_title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.page?.data.meta_description
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: this.page?.data.canonical
        },
        ...this.getAlternate
      ]
    }
  },
  computed: {
    ...mapState({
      staticReviews: 'staticReviews',
      windowBreakpoint: 'breakpoint'
    }),
    ...mapGetters({
      check: 'auth/user'
    }),
    getAlternate() {
      return this.page?.data?.alternate.map((alt) => {
        return {
          rel: 'alternate',
          hreflang: alt.lang,
          href: alt.url
        }
      }) || []
    },
    menuCategories() {
      return this.page.categories.filter((cat) => {
        return cat.in_menu === 1
      })
    },
    getSliderSettings: app => (name) => {
      let isSlider = app.$store.state.breakpoint.screen.widthMinCalc <= 1024
      if (name === 'sailing-holidays') {
        isSlider = true
      }
      const SETTINGS = {
        'sailing-holidays': {
          settings: {
            slidesToShow: 1,
            arrows: false,
            responsive: [
              {
                breakpoint: 576,
                settings: {
                  slidesToShow: 1,
                  dots: true,
                  arrows: false
                }
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 2,
                  dots: true,
                  arrows: false
                }
              },
              {
                breakpoint: 1023,
                settings: {
                  slidesToShow: 3,
                  dots: false,
                  arrows: true
                }
              }
            ]
          }
        },
        'discover-flotilla': {
          isSlider: true,
          settings: {
            arrows: false,
            slidesToShow: 1,
            responsive: [
              {
                breakpoint: 576,
                settings: {
                  slidesToShow: 2,
                  arrows: false
                }
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 2,
                  arrows: false,
                  dots: true
                }
              },
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 3,
                  dots: false,
                  arrows: true
                }
              }
            ]
          }
        }
      }
      return {
        body: {
          isSlider,
          settings: {
            type: 'slider',
            gaps: {
              value: 24
            }
          },
          ...SETTINGS[name]
        }
      }
    }
  },
  methods: {
    changeToggle(name, value = true, params = {type: 'touch'}) {
      if (params.type === 'mouse' && this.$store.state.breakpoint.screen.widthMinCalc <= 1200) {
        return
      }
      this.hover[name] = value
    },
    scrollToElement($element) {
      const offset = 50
      const bodyRect = document.body.getBoundingClientRect().top
      const elementRect = document.getElementById($element).getBoundingClientRect().top
      const elementPosition = elementRect - bodyRect
      const offsetPosition = elementPosition - offset

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      })
    }
  }
}
